import React, { useContext } from "react";
import { generatePath, Navigate, useSearchParams } from "react-router-dom";
import track from "react-tracking";

import { Center } from "@chakra-ui/react";

import EmailView from "components/Membership/EmailView";
import { PAGE_PATHS } from "config/routes";
import { SessionContext } from "contexts";
import { useFeatureFlags } from "contexts/FeatureFlagsContext/FeatureFlagsContext";
import { Loader } from "elements";
import useFetchOffers from "hooks/api/offers/useFetchOffers";
import { Offer } from "models/Offers";
import { usePageTracking } from "utils/tracking";
import { useTrackCheckout, useTrackOnce } from "utils/tracking/hooks";

const EmailPage = () => {
  usePageTracking();

  const { user } = useContext(SessionContext);
  const { isLoading: isLoadingOffers, data } = useFetchOffers();
  const { isLoading: isLoadingFeaturesFlags, featureFlags } = useFeatureFlags();

  const [searchParams] = useSearchParams();
  const { trackSubscriptionFunnel } = useTrackCheckout();

  useTrackOnce(
    (setTracked) => {
      if (!user) {
        trackSubscriptionFunnel("Email");
        setTracked();
      }
    },
    [user, trackSubscriptionFunnel]
  );

  if (isLoadingOffers || isLoadingFeaturesFlags) {
    return (
      <Center>
        <Loader />
      </Center>
    );
  }
  const offers = data?.offers as Record<string, Offer>;
  const renewOffer = data?.renewOffer as Offer;
  const { summerTime: summerTimeEnabled } = featureFlags;

  if (!user) {
    return <EmailView offers={offers} renewOffer={renewOffer} summerTimeEnabled={summerTimeEnabled} />;
  }
  if (user) {
    return (
      <Navigate to={{ pathname: generatePath(PAGE_PATHS.MEMBERSHIPS.BUY_PAGE), search: searchParams.toString() }} />
    );
  }
  return <Navigate to={{ pathname: generatePath(PAGE_PATHS.HOME_PAGE) }} />;
};
export default track({ page_type: "Memberships.Buy.Email" })(EmailPage);
